<template>
  <div class="digital-assets">
    <div class="container">
      <div class="asset-cards">
        <el-row :gutter="20">
          <!-- 修改 el-col 的 span 属性，根据屏幕大小动态调整 -->
          <el-col
            :span="isMobileOrTablet ? 24 : 12"
            v-for="(item, index) in displayItems"
            :key="item.id || index"
          >
            <div class="card">
              <div class="card-inner">
                <div class="image-container">
                  <img :src="item.image" alt="Digital Resource" />
                </div>
                <div class="card-content">
                  <div class="title-language">
                    <div class="digital-title">
                      {{ getCurrentLangValue(item, "title") }}
                    </div>
                    <div class="language-tags">
                      <div
                        v-for="(lang, index) in splitLanguageTags(
                          item.language
                        )"
                        :key="index"
                        class="language-tag"
                      >
                        {{ lang.trim() }}
                      </div>
                    </div>
                  </div>
                  <!-- 修改下载按钮 -->
                  <div class="digital-button" @click="download(item)">
                    <i class="el-icon-download"></i> {{ $store.state.isEn ? 'Download' : '下载' }}
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 修改分页组件 -->
      <div class="pagination-container">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DigitalAssets",
  data() {
    return {
      items: [],
      pageSize: 8,
      currentPage: 1,
      total: 0,
      isMobileOrTablet: false, // 新增变量用于判断是否为平板或移动端
    };
  },
  computed: {
    displayItems() {
      return this.items;
    },
    ...mapState(["isEn"]),
  },
  created() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  mounted() {
    this.init();
  },
  watch: {
    // 监听语言切换，重新计算显示内容
    isEn: {
      handler() {
        // 语言切换时重新计算displayItems
        this.$forceUpdate();
      },
      immediate: true,
    },
    // 监听页码变化，重新获取数据
    currentPage() {
      this.init();
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    // 获取当前语言环境的值
    getCurrentLangValue(item, fieldName) {
      if (!item[fieldName]) return "";

      const langIndex = this.$store.state.isEn; // 0 为中文，1 为英文
      const langKey = langIndex === 1 ? "en" : "cn";

      if (typeof item[fieldName] === "object" && item[fieldName] !== null) {
        return item[fieldName][langKey] || item[fieldName]["cn"] || "";
      } else {
        // 如果不是对象，直接返回原值
        return item[fieldName] || "";
      }
    },

    init() {
      // 获取数据
      this.$api.get(
        "/digital/list",
        {
          current: this.currentPage,
          pageSize: this.pageSize,
        },
        (res) => {
          if (res.code === 0) {
            // 处理接口返回的数据，按照规范建立字段映射关系
            this.items = res.data.map((item) => ({
              ...item,
              // 将中英文标题映射为规范的对象结构
              title: {
                cn: item.cnTitle,
                en: item.enTitle,
              },
              // 图片字段处理
              image:
                this.$store.state.isEn && item.imageEn
                  ? item.imageEn
                  : item.imageCn || require("@/assets/visitorGuide1.jpg"),
              // 语言标签
              language: item.label || "",
            }));

            this.total = res.total;
          } else {
            console.error("获取数据失败:", res.msg);
          }
        }
      );
    },
    handlePageChange(page) {
      this.currentPage = page;
    },
    download(item) {
      if (item.fileUrl) {
        // 使用a标签直接下载文件
        this.downloadFile(item.fileUrl, item);
      } else if (item.downloadUrl) {
        // 如果没有fileUrl，仍然支持原有的downloadUrl
        this.downloadFile(item.downloadUrl, item);
      } else {
        console.warn("没有可用的下载链接");
      }
    },

    // 统一的文件下载方法
    downloadFile(url, item) {
      // 构造文件名
      let fileName = "document";
      if (item.title && typeof item.title === "object") {
        fileName = this.$store.state.isEn ? item.title.en : item.title.cn;
      } else if (typeof item.title === "string") {
        fileName = item.title;
      }

      // 确保文件扩展名
      const fileExtension = url.toLowerCase().split(".").pop();
      if (fileExtension && !fileName.toLowerCase().endsWith(fileExtension)) {
        fileName += "." + fileExtension;
      }

      // 创建下载链接
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.target = "_blank"; // 新窗口打开，确保下载在某些浏览器中能正常工作

      // 添加到页面，触发点击，然后移除
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    checkScreenSize() {
      this.isMobileOrTablet = window.innerWidth <= 968;
    },
    splitLanguageTags(languageStr) {
      if (!languageStr) return [];
      // 按中英文逗号和中文顿号分割字符串
      return languageStr.split(/[，,、]/);
    },
  },
};
</script>

<style scoped>
.digital-assets {
  padding: 20px;
  margin-top: 130px;
}

.container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
}

.card {
  width: 648px;
  height: 440px;
  margin-bottom: 80px;
  transform: scale(1);
}

.card-inner {
  display: flex;
  height: 100%;
}

.image-container {
  width: 324px;
  height: 440px;
  overflow: hidden;
  flex: 0 0 auto; /* 添加此行，防止图片区域被挤压 */
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持图片比例并覆盖整个容器 */
}

.card-content {
  position: relative;
  width: auto;
  padding: 10px;
  flex: 1; /* 添加此行，让内容区域占用剩余空间 */
  min-width: 0; /* 防止内容溢出 */
}

.digital-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 20px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  flex: 1;
  margin-right: 10px;
}

.language-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  min-width: 80px;
  margin-top: 5px;
}

.language-tag {
  background: #ca9d76;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 400;
  display: inline-block;
  text-align: center;
  padding: 0 8px;
  height: 23px;
  line-height: 20px;
  margin-top: 0;
  position: relative;
  overflow: visible;
  background-size: cover;
  clip-path: polygon(
    100% 0%,
    100% 100%,
    77.67% 95%,
    58.33% 91%,
    41.33% 91.33%,
    21.33% 94.67%,
    0% 100%,
    0% 0%
  );
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1;
}

.card-content .digital-button {
  background: #ffffff;
  display: inline-block; /* 确保元素为行内块元素，以根据内容撑开宽度 */
  line-height: 30px;
  position: absolute;
  bottom: 15px;
  left: 15px;
  padding: 0 10px;
  height: 30px;
  border: 1px solid rgba(44, 44, 44, 1);
  border-radius: 2px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #000000;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  cursor: pointer;
}

/* 新增分页容器样式 */
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

/* 调整分页样式 */
.el-pagination {
  text-align: center;
  padding: 10px 0;
  background-color: #fff;
  border-radius: 4px;
}

.digital-assets >>> .el-pagination .number.active,
.digital-assets >>> .el-pagination .number.is-active {
  color: #ca9d76;
}

.digital-assets >>> .el-pagination .number:hover,
.digital-assets >>> .el-pagination .btn-prev:hover,
.digital-assets >>> .el-pagination .btn-next:hover {
  color: #ca9d76;
}

/* 响应式设计 - 大屏幕 */
@media (max-width: 1441px) {
  .digital-assets {
    margin-top: 110px;
  }
  .container {
    max-width: 1340px;
    padding: 0 20px;
  }

  .card {
    width: 648px;
    height: 440px;
    margin-bottom: 50px;
    transform: scale(0.95);
  }

  .card-inner {
    height: 100%;
  }
  .card-content {
    width: 264px;
    max-width: 264px;
  }

  .digital-title {
    font-size: 20px;
  }

  .language-tag {
    font-size: 14px;
  }

  .card-content .digital-button {
    font-size: 14px;
  }
}

/* 响应式设计 - 桌面常规屏幕 */
@media (max-width: 1300px) {
  .digital-assets {
    margin-top: 80px;
  }
  .container {
    max-width: 1140px;
    padding: 0 20px;
  }

  .card {
    width: 648px;
    height: 440px;
    margin-bottom: 30px;
    transform: scale(0.85);
  }

  .card-inner {
    height: 100%;
  }
  .card-content {
    width: 264px;
    max-width: 264px;
  }

  .digital-title {
    font-size: 20px;
  }

  .language-tag {
    font-size: 14px;
  }

  .card-content .digital-button {
    font-size: 14px;
  }
}
@media (max-width: 1200px) {
  .digital-assets {
    margin-top: 60px;
  }
  .container {
    max-width: 1140px;
    padding: 0 20px;
  }

  .card {
    width: 648px;
    height: 440px;
    margin-bottom: 0px;
    transform: scale(0.8);
  }

  .card-inner {
    height: 100%;
  }
  .card-content {
    width: 264px;
    max-width: 264px;
  }

  .digital-title {
    font-size: 18px;
  }

  .language-tag {
    font-size: 14px;
  }

  .card-content .digital-button {
    font-size: 14px;
  }
}

/* 新增平板和移动端样式 */
@media (max-width: 960px) {
  .digital-assets {
    margin-top: 80px;
  }
  .card {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    transform: scale(1);
  }
  .image-container {
    width: 252px;
    height: 330px;
    overflow: hidden;
    flex: 0 0 auto; /* 添加此行，防止图片区域被挤压 */
  }

  .image-container img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* 保持图片比例并覆盖整个容器 */
  }

  .card-content {
    position: relative;
    max-width: 272px;
    padding: 5px;
    flex: 1; /* 添加此行，让内容区域占用剩余空间 */
    min-width: 0; /* 防止内容溢出 */
  }

  /* 确保在平板设备上每行只显示一个卡片 */
  .el-col-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .digital-title {
    font-size: 16px;
  }
  .language-tag {
    font-size: 12px;
  }
}

/* 针对更小的移动设备屏幕进一步优化 */
@media (max-width: 768px) {
  .card {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    transform: scale(1);
  }
  .image-container {
    width: 219px;
    height: 286px;
    overflow: hidden;
    flex: 0 0 auto; /* 添加此行，防止图片区域被挤压 */
  }

  .image-container img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* 保持图片比例并覆盖整个容器 */
  }

  .card-content {
    position: relative;
    max-width: 272px;
    padding: 5px;
    flex: 1; /* 添加此行，让内容区域占用剩余空间 */
    min-width: 0; /* 防止内容溢出 */
  }
  .digital-title {
    font-size: 16px;
  }
  .language-tag {
    font-size: 12px;
  }
}
@media (max-width: 420px) {
  .card {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    transform: scale(1);
  }
  .image-container {
    width: 168px;
    height: 220px;
    overflow: hidden;
    flex: 0 0 auto; /* 添加此行，防止图片区域被挤压 */
  }

  .image-container img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* 保持图片比例并覆盖整个容器 */
  }

  .card-content {
    position: relative;
    max-width: 172px;
    padding: 5px;
    flex: 1; /* 添加此行，让内容区域占用剩余空间 */
    min-width: 0; /* 防止内容溢出 */
  }
  .digital-title {
    font-size: 14px;
  }
  .language-tag {
    font-size: 10px;
  }
}
</style>